import { ToolbarButton, TableDataRequest, Modal } from '@fl/cmsch-fe-library';
import React, { FC, memo, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Opt } from 'ts-opt';
import { Calf } from 'api/gen/Calf';
import { ConnectedTable } from 'utils/tables';
import { ExportPdfForm } from '../export-pdf-form';
import { getCalfBrowserColumns } from './columns';
import { animalBrowserAction, simpleAnimalBrowserSelector } from '../../model';
import { useAnimalsBrowserBasicSetup } from '../../utils/use-animals-browser-basic-setup';
const CalfBrowserTableBase: FC = _ => {
  const dispatch = useDispatch();
  const printInProgress = useSelector(simpleAnimalBrowserSelector.printInProgress);
  const exportInProgress = useSelector(simpleAnimalBrowserSelector.exportInProgress);
  const {
    tCommon,
    t,
    exportDisabled,
    disabledExportTitle,
    handleOpenExportPdfModal,
    femalesForExport,
    bullsForExport,
    contentForPdfExportIsFilled,
    handleSubmitModal,
    handleCloseModal,
    exportToCSV,
    handleMotherLink,
    id
  } = useAnimalsBrowserBasicSetup('CALVES');
  const getCalves = useCallback((tableDataRequest: Opt<TableDataRequest<Calf>>) => {
    dispatch(animalBrowserAction.getCalfBrowserTableData(tableDataRequest, id));
  }, [dispatch, id]);
  const headerButtons: Array<ToolbarButton> = useMemo(() => [{
    disabled: exportDisabled,
    onClick: handleOpenExportPdfModal,
    title: t('printIkKb'),
    disabledTitle: disabledExportTitle,
    id: 'exportCalvesPdf',
    role: 'export',
    loading: printInProgress
  }, {
    disabled: exportDisabled,
    onClick: exportToCSV,
    title: tCommon('downloadCsv'),
    disabledTitle: disabledExportTitle,
    id: 'exportCalves',
    role: 'export',
    loading: exportInProgress
  }], [exportDisabled, handleOpenExportPdfModal, tCommon, disabledExportTitle, printInProgress, exportInProgress, exportToCSV, t]);
  return <>
            <ConnectedTable tableId="calfBrowser" columns={getCalfBrowserColumns(handleMotherLink)} onFetchTableData={getCalves} rowDataPageSelector={simpleAnimalBrowserSelector.calfBrowserPage} enableTableSettings enableTableUserSettings headerButtons={headerButtons} paginationPosition="both" withoutVerticalScrollbar lazyLoadingLimit={20} showFulltextFilter data-sentry-element="ConnectedTable" data-sentry-source-file="index.tsx" />
            <Modal title={t('printIkKb')} visible={contentForPdfExportIsFilled} onCancel={handleCloseModal} footer={null} data-sentry-element="Modal" data-sentry-source-file="index.tsx">
                <ExportPdfForm tableContainsFemales={femalesForExport.length > 0} tableContainsBulls={bullsForExport.length > 0} onCancel={handleCloseModal} onSubmit={handleSubmitModal} isFromCows={false} data-sentry-element="ExportPdfForm" data-sentry-source-file="index.tsx" />
            </Modal>
        </>;
};

/**
 * Renders the calf table plus the print/export modal for the basic calf browser.
 *
 * @returns The calf-browser table with its export modal.
 */
export const CalfBrowserTable = memo(CalfBrowserTableBase);